const config = {
  BACKEND_API: [
    process.env.REACT_APP_BACKEND_API_1,
    process.env.REACT_APP_BACKEND_API_2,
  ],
};

export default config;
